var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { services } from '../../../shared/api/services';
import { ProductTable } from '../../sections/products-table/products-table';
import { PageHeading } from '../../shared';
import { Container } from '../../shared';
export var ProductsPage = function () {
    var _a = useState([]), productCategories = _a[0], setProductCategories = _a[1];
    var _b = useState(0), productCategory = _b[0], setProductCategory = _b[1];
    var _c = useState(' '), keyPressed = _c[0], setKeyPressed = _c[1];
    var _d = useState([]), products = _d[0], setProducts = _d[1];
    var _e = useState([]), rateTypes = _e[0], setRateTypes = _e[1];
    var _f = useState(' '), searchTerm = _f[0], setSearchTerm = _f[1];
    var _g = useState('Description'), sortColumn = _g[0], setSortColumn = _g[1];
    var _h = useState('Asc'), sortOrder = _h[0], setSortOrder = _h[1];
    var _j = useState(0), rateType = _j[0], setRateType = _j[1];
    var _k = useState('No products are currently available'), noRowsMessage = _k[0], setnoRowsMessage = _k[1];
    var _l = useState(false), isFilterValueChanged = _l[0], setIsFilterValueChanged = _l[1];
    var pageSize = 10;
    var handleKey = function (e) {
        setKeyPressed(e.currentTarget.value);
    };
    var updateProducts = function (category, type, term, pageNumber, pageSize, column, order) { return __awaiter(void 0, void 0, void 0, function () {
        var results, updatedProducts, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, services.getProducts(category, type, term !== null && term !== void 0 ? term : '', pageNumber, pageSize, column, order)];
                case 1:
                    results = _a.sent();
                    if (results.data && results.data.length > 0) {
                        updatedProducts = results.data.map(function (product) { return (__assign(__assign({}, product), { ltv: "".concat(product.minimumLoanToValue, " - ").concat(product.maximumLoanToValue) })); });
                        setProducts(updatedProducts);
                        setnoRowsMessage('');
                        return [2 /*return*/, updatedProducts];
                    }
                    else {
                        setProducts([]);
                        setnoRowsMessage('No products are currently available');
                        return [2 /*return*/, []];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setProducts([]);
                    setnoRowsMessage('Error fetching products');
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchProducts = function (searchTerm) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSearchTerm(searchTerm);
                    setnoRowsMessage('Loading...');
                    return [4 /*yield*/, updateProducts(productCategory, rateType, searchTerm, 1, pageSize)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var fetchPageData = function (pageNumber, pageSize) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateProducts(productCategory, rateType, searchTerm, pageNumber, pageSize, sortColumn, sortOrder)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var fetchSortedData = function (column, order) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateProducts(productCategory, rateType, searchTerm, 1, pageSize, column.id, order)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var rateTypeChangeHandler = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setRateType(Number(e.currentTarget.value));
                    setIsFilterValueChanged(true);
                    return [4 /*yield*/, updateProducts(productCategory, Number(e.currentTarget.value), searchTerm, 1, pageSize, sortColumn, sortOrder)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var productListChangeHandler = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setProductCategory(Number(e.currentTarget.value));
            setIsFilterValueChanged(true);
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        var rateTypes = [
            { id: 0, name: 'All' },
            { id: 1, name: 'Fixed' },
            { id: 2, name: 'Variable' },
        ];
        setRateTypes(rateTypes);
        var defaultProductCategory = {
            id: 0,
            name: 'All',
        };
        services.getProductCategories().then(function (result) {
            if (result && (result === null || result === void 0 ? void 0 : result.data.length) > 0) {
                setProductCategories(__spreadArray([defaultProductCategory], result.data, true));
            }
        });
    }, []);
    useEffect(function () {
        fetchProducts(keyPressed);
    }, [productCategory]);
    useEffect(function () {
        fetchProducts(keyPressed);
    }, [keyPressed]);
    return (React.createElement("section", null,
        React.createElement(PageHeading, { headingLevel: 2, title: "Products", icon: "products", mb: 6 }),
        React.createElement(Container, { fullWidth: true },
            React.createElement(ProductTable, { productList: products, productCategories: productCategories, rateTypes: rateTypes, handleKey: handleKey, pageFunction: fetchPageData, sortFunction: fetchSortedData, rateTypeChangeHandler: rateTypeChangeHandler, productListChangeHandler: productListChangeHandler, selectedProductCategory: productCategory, selectedRateType: rateType, noRowsMessage: noRowsMessage, isFilterValueChanged: isFilterValueChanged, setIsFilterValueChanged: setIsFilterValueChanged }))));
};
